import React, {useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useReactToPrint} from "react-to-print";
import {PDFDownloadLink} from "@react-pdf/renderer";
import Button from "@mui/material/Button";
import {useAuth} from "../../../../hooks/useAuth";
import {APIGetReport} from "../api/schoolReports";
import Loading from "../../../../shared/ui/Loading";
import Icon from "../../../../shared/ui/Icon";
import ReportPDF from "../components/ReportPDF";
import Report, {ReportExportHandle} from "../components/Report";
import moment from "moment/moment";

const SchoolReport = ({type}: { type: string }) => {
    const {id = ""} = useParams();
    const {update, tenant} = useAuth();
    const reportPrintRef = useRef(null);
    const reportComponentRef = useRef<ReportExportHandle | null>(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState<boolean>(true);
    const [reportData, setReportData] = useState<any>();
    const [generatePdf, setGeneratePdf] = useState(false);
    const [images, setImages] = useState<any[]>([]);
    const [click, setClick] = useState(false);
    const [dates, setDates] = useState({startDate: "", endDate: ""});

    useEffect(() => {
        if (id !== "") {
            setLoading(true);
            APIGetReport({id: id})
                .then((response) => {
                    if (response.data.success) {
                        let data = response.data.data.item;
                        setReportData(data);
                        setDates({startDate: moment(data.start_date).locale("ro").format("DD.MM.YYYY"), endDate: moment(data.end_date).locale("ro").format("DD.MM.YYYY")});
                    } else {
                        update("error", {show: true, code: "A002"});
                    }
                })
                .catch(() => {
                    // console.log("getReport ERR", err);
                    update("error", {show: true, code: "A001"});
                })
                .finally(() => {
                    setLoading(false);
                })
        } else {
            navigate("/rapoarte-scoala");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const PDFGenerateHandler = async () => {
        try {
            if (!reportComponentRef.current) {
                throw new Error("Report component not ready");
            }

            const exportedImages = await reportComponentRef.current.exportCharts();
            setImages(exportedImages);
            setGeneratePdf(true);
        } catch (e) {
            console.error("Error generating images for PDF:", e);
        }
    };

    const handlePrint = useReactToPrint({
        content: () => reportPrintRef.current,
    });

    return (
        <>
            {loading ? (
                    <Loading show={true}/>
                ) : (
                    <>
                        <div ref={reportPrintRef}>
                            <Report ref={reportComponentRef} data={reportData}/>
                        </div>
                        {reportData.payload.finished_tests_count !== 0 && (
                            <div className="print-bar screen no-print">
                                <Button type="submit" variant="contained" onClick={handlePrint}
                                        style={{marginRight: 20}}>
                                    Tipărește
                                </Button>
                                {generatePdf && images.length > 0 ? (
                                    <PDFDownloadLink document={
                                        <ReportPDF
                                            data={reportData}
                                            images={images}
                                            schoolName={tenant.name}
                                        />} fileName={`RaportConsolidatEducational-${reportData.subject}-${dates.startDate}-${dates.endDate}.pdf`}>
                                        {({blob, url, loading, error}) =>
                                            loading ? <>Se generează <Icon icon="far circle-notch" spin={true}
                                                                           className="fa-faster"
                                                                           fixedWidth={true}
                                                                           sx={{display: "inline"}}/></> : "Descarcă pdf"
                                        }
                                    </PDFDownloadLink>
                                ) : (
                                    <Button variant="contained" onClick={() => {
                                        setClick(true);
                                        window.setTimeout(() => {
                                            PDFGenerateHandler();
                                        }, 100);

                                    }}>
                                        {!click ? "Generează pdf" : <>Se generează <Icon icon="far circle-notch"
                                                                                         spin={true}
                                                                                         className="fa-faster"
                                                                                         fixedWidth={true}
                                                                                         sx={{display: "inline"}}/></>}
                                    </Button>
                                )}
                            </div>
                        )}
                    </>
                )
            }
        </>
    )
}

export default SchoolReport;